"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var profile_avatar_1 = require("ayvri-ui/lib/profile-avatar");
var React = require("react");
var react_redux_1 = require("react-redux");
var env_1 = require("../../helpers/env");
var csrf = require("../../pages/csrfUtils");
var user_1 = require("../../reducers/user");
var client_1 = require("../../rpc/client");
var profile_1 = require("../../services/profile");
var types_1 = require("../../types");
// tslint:disable-next-line:no-var-requires
var style = require('./profile.css');
exports.setProfile = function (userProfile, isOwner) {
    if (isOwner === void 0) { isOwner = false; }
    return {
        type: 'SET_PROFILE',
        avatarUrl: userProfile.avatarUrl,
        name: userProfile.name,
        handle: userProfile.handle,
        isOwner: isOwner,
    };
};
exports.updateUserName = function (name) {
    return function (dispatch, getState) {
        var originalName = getState().profile.name;
        dispatch(exports.setName(name));
        dispatch(user_1.updateUser(__assign(__assign({}, getState().user), { name: name })));
        return fetch('/settings', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({
                setting: 'name',
                value: name,
                updateType: types_1.UserUpdateType.userProfile,
            }),
            headers: csrf.withCSRFToken({ 'Content-Type': 'application/json' }),
        }).catch(function (_) {
            if (!originalName || originalName.length === 0) {
                return;
            }
            dispatch(exports.setName(originalName));
            dispatch(user_1.updateUser(__assign(__assign({}, getState().user), { name: originalName })));
        });
    };
};
exports.updateAvatar = function (file) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var originalAvatar, p, url, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    originalAvatar = getState().profile.avatarUrl;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    dispatch(exports.setAvatarIsLoading(true));
                    p = client_1.client(profile_1.profileService, new client_1.FetchClientTransport('/rpc/profile', csrf.csrfToken()).transport());
                    return [4 /*yield*/, p.getUploadUrl(file.name.split('.').splice(-1)[0])];
                case 2:
                    url = (_a.sent()).unwrap();
                    return [4 /*yield*/, fetch(url.uploadUrl, {
                            method: 'PUT',
                            body: file,
                        })];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, p.setAvatar(url.uploadToken)];
                case 4:
                    _a.sent();
                    dispatch(exports.setAvatar(url.publicUrl));
                    dispatch(user_1.updateUser(__assign(__assign({}, getState().user), { avatarUrl: url.publicUrl })));
                    dispatch(exports.setAvatarIsLoading(false));
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    console.error(e_1);
                    dispatch(exports.setAvatar(originalAvatar));
                    dispatch(exports.setAvatarIsLoading(false));
                    window.alert('Failed to update avatar');
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
exports.setName = function (name) {
    return {
        type: 'SET_NAME',
        name: name,
    };
};
exports.setAvatar = function (avatarUrl) {
    return {
        type: 'SET_AVATAR',
        avatarUrl: avatarUrl,
    };
};
exports.setAvatarIsLoading = function (avatarIsLoading) {
    return {
        type: 'SET_AVATAR_IS_LOADING',
        avatarIsLoading: avatarIsLoading,
    };
};
exports.profile = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'SET_PROFILE':
            return {
                avatarUrl: action.avatarUrl,
                name: action.name,
                handle: action.handle,
                isOwner: action.isOwner,
            };
        case 'SET_NAME':
            return __assign(__assign({}, state), { name: action.name });
        case 'SET_AVATAR':
            return __assign(__assign({}, state), { avatarUrl: action.avatarUrl });
        case 'SET_AVATAR_IS_LOADING':
            return __assign(__assign({}, state), { avatarIsLoading: action.avatarIsLoading });
        default:
            return state;
    }
};
// TODO: replace state with page state template
var mapStateToProps = function (state) {
    return {
        profile: state.profile,
    };
};
// TODO: Typescript is being a dick with redux-thunk
var mapDispatchToProps = function (dispatch) {
    return {
        updateUserName: function (name) { return dispatch(exports.updateUserName(name)); },
        updateAvatar: function (file) { return dispatch(exports.updateAvatar(file)); },
    };
};
exports.getUserImageUrl = function (user) {
    return user.avatarUrl || env_1.env().staticSrcPath() + '/assets/images/logos/_a_transparent.svg';
};
exports.ProfileImage = function (user) {
    return (React.createElement("img", { className: !user.avatarUrl ? style.withBackground : style.avatar, src: user.avatarUrl || env_1.env().staticSrcPath() + '/assets/images/logos/_a_transparent.svg' }));
};
exports.getLargerProfileImage = function (url) {
    return url ? (url.includes('?') ? url + '&' : url + '?') + 'type=large&sz=128' : undefined;
};
var NameWithEdit = /** @class */ (function (_super) {
    __extends(NameWithEdit, _super);
    function NameWithEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NameWithEdit.prototype.componentWillMount = function () {
        this.setState({ editMode: false, name: this.props.profile.name || '' });
        this.startEdit = this.startEdit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.saveName = this.saveName.bind(this);
    };
    NameWithEdit.prototype.startEdit = function () {
        this.setState({ editMode: true, name: this.state.name });
    };
    NameWithEdit.prototype.updateField = function (text) {
        this.setState({ name: text });
    };
    NameWithEdit.prototype.saveName = function () {
        var name = this.state.name.trim();
        if (name.length === 0) {
            return this.cancel();
        }
        this.setState({ editMode: false });
        this.props.updateUserName(name);
    };
    NameWithEdit.prototype.cancel = function () {
        this.setState({ editMode: false, name: this.props.profile.name || '' });
    };
    NameWithEdit.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: style.name },
            this.state.editMode ? (React.createElement("form", { onSubmit: this.saveName },
                React.createElement("input", { type: 'text', value: this.state.name, onChange: function (e) { return _this.updateField(e.target.value); }, autoFocus: true }),
                React.createElement("div", { className: style.editNameSaveCancel },
                    React.createElement("div", { className: style.save, onClick: this.saveName }, "save"),
                    React.createElement("div", { className: style.cancel, onClick: this.cancel }, "cancel")))) : (React.createElement("a", { href: '/profile/' + this.props.profile.handle, className: style.profileLink }, this.state.name)),
            this.props.profile.isOwner && !this.state.editMode ? (React.createElement("div", { className: style.edit },
                React.createElement("img", { onClick: this.startEdit, src: env_1.env().staticSrcPath() + "/assets/images/icons/pencil.svg", alt: 'edit name' }))) : null));
    };
    return NameWithEdit;
}(React.Component));
exports.profileComponent = function (_a) {
    var profile = _a.profile, updateUserName = _a.updateUserName, updateAvatar = _a.updateAvatar;
    var avatar = (React.createElement(profile_avatar_1.ProfileAvatar, { imageUrl: exports.getLargerProfileImage(profile.avatarUrl), owner: !!profile.isOwner, onFileChange: updateAvatar, loading: !!profile.avatarIsLoading }));
    return (React.createElement("div", { className: style.profileComponent },
        profile.isOwner ? (avatar) : (React.createElement("a", { href: '/profile/' + profile.handle, className: style.profileLink }, avatar)),
        React.createElement(NameWithEdit, { profile: profile, updateUserName: updateUserName })));
};
exports.Profile = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.profileComponent);
exports.smallProfile = function (profile, alternateClass) {
    var userImage = exports.getUserImageUrl(profile);
    return (React.createElement("div", { className: style.smallProfile + (alternateClass ? ' ' + alternateClass : '') },
        React.createElement("img", { className: style.smallAvatar + (!profile.avatarUrl ? ' ' + style.withBackground : ''), src: userImage }),
        profile && profile.name ? React.createElement("div", { className: style.name }, profile.name) : ''));
};
